<template>
  <p>
    For inquiries relating to the scientific content of the workshop, please contact the VIZBI
    Committee:
  </p>
  <p><Email to="vizbi-contact" /></p>
  <p>
    For inquiries about practical matters (registration, transport, hotels etc.), please contact:
  </p>
  <p style="margin-left: 2.5em;">
    Broad Events:<br /><br />
    Tel: +1 617-714-7000<br /><br />
    7 Cambridge Center<br />
    Office 7021<br />
    Cambridge MA 02142<br />
    USA
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
</script>
